module.exports = __webpack_public_path__ + "static/media/sixteenth_viewpoint_bookstore.da19f7d0.mp4";